<template>
  <div class="empty-notice" :class="customClass">
    <span class="material-icons empty-notice__icon" :class="variantClass">{{ resolvedIcon }}</span>
    <span class="empty-notice__text" :class="variantClass">{{ text }}</span>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  text: {
    type: String,
    default: ''
  },
  variant: {
    type: String,
    default: 'info'
  },
  icon: {
    type: String,
    default: ''
  },
  customClass: {
    type: [String, Array, Object],
    default: ''
  }
});

const variantClass = computed(() => props.variant || 'info');
const resolvedIcon = computed(() => {
  if (props.icon) return props.icon;
  switch (props.variant) {
    case 'danger':
      return 'not_interested';
    case 'warning':
      return 'report_problem';
    case 'success':
      return 'check_circle_outline';
    case 'info':
    default:
      return 'error_outline';
  }
});
</script>

<style scoped>
.empty-notice {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 16px 20px;
  background: transparent;
  border: none;
}

.empty-notice__icon {
  font-size: 64px;
  line-height: 1;
  margin-bottom: 8px;
}

.empty-notice__text {
  font-size: 18px;
  font-weight: 700;
  line-height: 1.3;
}

.info {
  color: #4db7fe;
}

.danger {
  color: #dc3545;
}

.warning {
  color: #f0ad4e;
}

.success {
  color: #36b453;
}
</style>
